import { Option } from 'shared/components/Select/models/Option';
import { mapAccessSystemLabel } from 'shared/constants/filters/advanced/accessSystemLabel';
import { EAccessSystem } from 'shared/types/filters/advanced/accessSystem';

export const accessSystemOptions = [
  new Option(EAccessSystem.WithoutAccessSystem, mapAccessSystemLabel[EAccessSystem.WithoutAccessSystem]),
  new Option(EAccessSystem.WithAccessSystem, mapAccessSystemLabel[EAccessSystem.WithAccessSystem]),
];
